import { usePetitionGuidesPageData } from '#src/app/pages/petitionGuides/pageContext';

type RelatedArticle = {
	articleTitle: string;
	slug: string;
};

type Result = ModelHookResult<{
	relatedArticles: readonly RelatedArticle[];
}>;

export function useRelatedArticles(): Result {
	const {
		data: { relatedArticles },
	} = usePetitionGuidesPageData();

	return {
		data: {
			relatedArticles,
		},
	};
}
